export * from './lib/login-page.component';
export * from './lib/config/login-page-config';
